import { render, staticRenderFns } from "./setSceneDialog.vue?vue&type=template&id=e477ef4a&scoped=true"
import script from "./setSceneDialog.vue?vue&type=script&lang=js"
export * from "./setSceneDialog.vue?vue&type=script&lang=js"
import style0 from "./setSceneDialog.vue?vue&type=style&index=0&id=e477ef4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e477ef4a",
  null
  
)

export default component.exports